import React from 'react'
import { Navigate, useLocation } from 'react-router'
import { useUserState } from '~/atoms/UserState'
import { ApplicationRoutes } from '~/types/RoutingTypes'

import {
  type HotelsRouteAccess,
  resolveHotelsAccessRedirect,
} from './hotelsPermissions'
import { useHotelsPermissions } from './useHotelsPermissions'

interface HotelsAccessGateProps {
  requiredAccess: HotelsRouteAccess
  children: React.ReactNode
}

export const HotelsAccessGate = ({
  requiredAccess,
  children,
}: HotelsAccessGateProps) => {
  const location = useLocation()
  const { isReady, pbx } = useUserState({ canAutoRefresh: false })
  const { permissions, firstAllowedRoute } = useHotelsPermissions()

  if (!isReady) {
    return null
  }

  const redirectTo = resolveHotelsAccessRedirect({
    pbx,
    requiredAccess,
    permissions,
    currentPathname: location.pathname,
  })

  if (redirectTo) {
    return <Navigate to={redirectTo} replace />
  }

  if (!firstAllowedRoute) {
    return <Navigate to={ApplicationRoutes.CALLS} replace />
  }

  return <>{children}</>
}
